"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mountThemeClassName = void 0;
var _theming = require("../theming.types");
var _constants = require("../constants");
var mountThemeClassName = exports.mountThemeClassName = function mountThemeClassName(name) {
  if (name && Object.values(_theming.Theme).includes(name)) {
    return "".concat(_constants.THEME_CLASSNAME, "--").concat(name);
  }
  return "".concat(_constants.THEME_CLASSNAME, "--").concat(_theming.Theme.DEFAULT);
};